import { ITableTab } from "../components/Table/components/TableTabs/TableTabs.types";
import { IRecordCount, IWhatsappCount } from "../redux/common/common.types";
import { IndianPriceFormatter } from "./formatWithCommas";

export const createTabsWithRecordcounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IRecordCount[]
): ITableTab[] => {
  let totalCount = 0;

  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find(
      (obj) => (obj.status || "").toLowerCase() === item.value.toLowerCase()
    );
    const count = countObj ? countObj.count : 0;
    totalCount = totalCount + count;
    return {
      label: item.label,
      value: item.value,
      count: count,
      variant: item.variant,
    };
  });
  mergedArray.unshift({
    label: "All",
    value: "-1",
    count: totalCount,
    variant: "primary",
  });
  return mergedArray as ITableTab[];
};

export const createTabsWithWhatsappcounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IWhatsappCount[]
): ITableTab[] => {
  let totalCount = 0;

  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find(
      (obj) => (obj.status || "").toLowerCase() === item.value.toLowerCase()
    );
    const count = countObj ? countObj.cnt : 0;
    totalCount = totalCount + count;
    return {
      label: item.label,
      value: item.value,
      count: count,
      variant: item.variant,
    };
  });
  mergedArray.unshift({
    label: "All",
    value: "-1",
    count: totalCount,
    variant: "primary",
  });
  return mergedArray as ITableTab[];
};

export const createTabsWithPaymentTransactionCounts = (
  mainData: { label: string; value: string; variant: string }[],
  recordCounts: IRecordCount[]
): ITableTab[] => {
  const mergedArray = mainData.map((item) => {
    const countObj = recordCounts.find(
      (obj) => (obj.status || "").toLowerCase() === item.value.toLowerCase()
    );
    const count = countObj ? countObj.count : 0;
    return {
      label: item.label,
      value: item.value,
      count: IndianPriceFormatter(count),
      variant: item.variant,
    };
  });

  return mergedArray as unknown as ITableTab[];
};
